import { el, inject } from "@dhx/ts-common/dom";
import { getValidationMessage, isEmptyObj } from "../helper";
import { Combobox, ComboboxEvents } from "@dhx/ts-combobox";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";
import { Label } from "./helper/label";
import { ValidationStatus, ICombo, BaseElementEvent, IBaseComboEventHandlersMap } from "../types";


export class Combo extends Label {
	public config: ICombo;
	public combobox: Combobox;
	public events: IEventSystem<BaseElementEvent, IBaseComboEventHandlersMap> = new EventSystem();

	constructor(config: ICombo) {
		super(null, config);
		this.setConfig(config);
	}
	clear(): void {
		this.combobox.clear();
		this.paint();
	}
	getValue(): string | string[] {
		if (this.config.multiselection) {
			return this.combobox.getValue(true);
		} else {
			return this.combobox.getValue() || "";
		}
	}
	setValue(value: string | string[]): void {
		if (value) {
			this.combobox.setValue(value);
		}
		this.paint();
	}
	setConfig(config: ICombo): void {
		if (isEmptyObj(config)) {
			return;
		}
		if (this.combobox) {
			this.combobox.destructor();
		}
		this.config = {
			type: this.config.type,
			id: this.config.id,
			name: this.config.name,
			value: ""
		};
		const comboConfig = {};
		for (const key in config) {
			if (key !== "id" && key !== "type" && key !== "name") {
				this.config[key] = config[key];
				if (key !== "validation") {
					comboConfig[key] = config[key];
				}
			}
		}
		this.combobox = new Combobox(null, comboConfig);
		this.combobox.events.on(ComboboxEvents.change, change => {
			this.events.fire(BaseElementEvent.change, [change]);
		});
		this.events.fire(BaseElementEvent.configUpdate, [this.config]);
		this.setValue(this.config.value);
		this.events.on(BaseElementEvent.change, change => {
			if (change !== "load") {
				this.validate();
			}
		});
		this.clearValidate();
	}
	validate(): boolean {
		const value = this.combobox.getValue();
		const { validation, required } = this.config;
		if (validation) {
			const isValid = this.config.validation(value);
			this.config.$validationStatus = isValid
				? ValidationStatus.success
				: ValidationStatus.error;
			this._validationStatus();
			this.paint();
			return isValid;
		} else if (required) {
			this.config.$validationStatus = Boolean(value)
				? ValidationStatus.success
				: ValidationStatus.error;
			this._validationStatus();
			this.paint();
			return Boolean(value);
		} else {
			this.paint();
			return true;
		}
	}
	clearValidate(): void {
		this.config.$validationStatus = ValidationStatus.pre;
		this._validationStatus();
		this.paint();
	}
	getWidget(): Combobox {
		return this.combobox;
	}
	protected _validationStatus(): void {
		switch (this.config.$validationStatus) {
			case ValidationStatus.pre:
				this.combobox.config.css = this.config.css || "";
				break;
			case ValidationStatus.success:
				this.combobox.config.css = (this.config.css || "") + "dhx_form-group--state_success";
				break;
			case ValidationStatus.error:
				this.combobox.config.css = (this.config.css || "") + "dhx_form-group--state_error";
				break;
			default:
				this.combobox.config.css = this.config.css || "";
				break;
		}
	}
	protected _getRootView(): any {
		this.combobox.paint();
		return this.combobox.getRootView();
	}
	protected _draw() {
		const { labelWidth, labelInline, $validationStatus } = this.config;
		return el(".dhx_form-group", {
		}, [
			inject(this._getRootView()),
			el("div", {
				style: {"margin-left": `${labelWidth && labelInline ? `calc(${labelWidth} + 16px)` : ""}`},
				class: $validationStatus === 1 ? "dhx_form-group--state_error" : $validationStatus === 2 ? "dhx_form-group--state_success" : "",
			}, [
				el("span.dhx_input__caption", getValidationMessage(this.config))
			]),
		]);
	}
}